import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, PropType } from "vue";
import BaseInput from "@/components/shared/inputs/base/BaseInput.vue";
import { InputMode } from "@/types";


const __default__ = {
  name: "TextInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: String,
    default: "text",
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  maxlength: {
    type: Number,
  },
  hasClearButton: {
    type: Boolean,
    default: true,
  },
  value: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
  inputmode: {
    type: String as PropType<InputMode>,
    default: "",
  },
  enableClearText: {
    type: Boolean,
    default: true,
  },
  rules: {
    type: Object,
  },
  required: {
    type: Boolean,
    default: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onFocused", "onBlurred", "onInput", "update:value"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const inputValue = computed({
  get(): string {
    return props.value as string;
  },
  set(inputValue: string) {
    emit("update:value", inputValue);
  },
});

const baseInput = ref<InstanceType<typeof BaseInput>>();

const onFocused = () => {
  emit("onFocused");
};
const onBlurred = () => {
  emit("onBlurred");
};

const focus = () => {
  baseInput.value?.focusInputField();
};

__expose({
  focus,
});

const __returned__ = { props, emit, inputValue, baseInput, onFocused, onBlurred, focus, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})